import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ModalDeleteProduct.module.scss';

const ModalDeleteProduct = ({ title, message, onClose, onConfirm, icon }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="ModalDeleteProduct__modal" isOpen withFooter>
      <SalonModal.Body>
        <IconStatus variant={icon}>
          <Icon variant={icon} />
        </IconStatus>

        <div className={CN.contentModal}>
          <div className={CN.titleModal}>{title}</div>
          <div className={CN.textModal}>{message}</div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="slim" onClick={onClose}>
          {t('stocks.managerLayout.deleteProductModal.backButton')}
        </Button>
        <Button variant="primaryForce" onClick={onConfirm}>
          {t('stocks.managerLayout.deleteProductModal.deleteButton')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default ModalDeleteProduct;
